module.exports = __webpack_public_path__ + "img/3.bac91193.jpg";